export default "__VITE_ASSET__BEuskgAD__"